///////////////     BROWSER     /////////////////////
export { Renderer } from './files/browser/render';
export { addMultiEvent, multiEvent } from './files/browser/events';
///////////////     NODE JS     /////////////////////
export { resolveLocalIPv4Address } from './files/node/network';
export { isNodeEnvironment } from './files/node/is-node';
//////////     BROWSER & NODE JS     ////////////////
export { clamp, parseRatio } from './files/helpers';
export { isObject, isNullish, isNil, isPlainObject } from './files/guards';
export { arrayFix, arrayUnion } from './files/arrays';
export { deepMerge, deepClone, shallowAssign, deepAssign } from './files/objects';
export { timeDelay, timeWait, timeLoop } from './files/time';
//# sourceMappingURL=index.js.map